import { Box } from "native-base";
import { InterfaceBoxProps } from "native-base/lib/typescript/components/primitives/Box";
import React from "react";
import type { LatLng, Region } from "react-native-maps";
import MapView, { Marker as MVMarker } from "react-native-maps";

import { isNativeDevice } from "@/utils/platform";

const Marker = isNativeDevice ? MVMarker : ((MapView as any).Marker as typeof MVMarker);

type MapProps = {
  region?: Region;
  coordinate: LatLng;
} & InterfaceBoxProps;

const Map = ({ region, coordinate, ...props }: MapProps) => {
  return (
    <Box {...props}>
      <MapView
        region={region}
        // @ts-ignore
        options={{ mapTypeControl: false, streetViewControl: false }}
        style={{
          width: "100%",
          height: "100%",
        }}>
        <Marker coordinate={coordinate} />
      </MapView>
    </Box>
  );
};

export default Map;
